import { RoleShell } from "./RoleShell";
import { NAV_COPY, NAV_ICONS } from "../lib/navCopy";

const NAV_SECTIONS = [
  {
    label: NAV_COPY.sections.overview,
    items: [{ to: "/admin", label: NAV_COPY.common.dashboard, icon: NAV_ICONS.dashboard, end: true }],
  },
  {
    label: NAV_COPY.sections.companies,
    items: [
      { to: "/admin/companies/clients", label: NAV_COPY.admin.clients, icon: NAV_ICONS.clients, exact: true },
      { to: "/admin/companies/consultancies", label: NAV_COPY.admin.consultancies, icon: NAV_ICONS.consultancies, exact: true },
    ],
  },
  {
    label: NAV_COPY.sections.people,
    items: [
      { to: "/admin/recruiters", label: NAV_COPY.common.recruiters, icon: NAV_ICONS.recruiters },
      { to: "/admin/affiliates", label: NAV_COPY.common.affiliates, icon: NAV_ICONS.affiliates, exact: true },
      { to: "/admin/people/hr", label: NAV_COPY.admin.clientHr, icon: NAV_ICONS.clientHr, exact: true },
      { to: "/admin/people/consultancy", label: NAV_COPY.admin.consultancyAdmins, icon: NAV_ICONS.consultancyAdmins, exact: true },
      { to: "/admin/people/admins", label: NAV_COPY.common.admins, icon: NAV_ICONS.admins, exact: true },
    ],
  },
  {
    label: NAV_COPY.sections.hiring,
    items: [
      { to: "/admin/jobs", label: NAV_COPY.admin.jobs, icon: NAV_ICONS.jobs },
      { to: "/admin/applications", label: NAV_COPY.common.submissions, icon: NAV_ICONS.submissions },
      { to: "/admin/disputes", label: NAV_COPY.common.disputes, icon: NAV_ICONS.disputes },
    ],
  },
  {
    label: NAV_COPY.sections.finance,
    items: [
      { to: "/admin/finance/invoices", label: NAV_COPY.admin.invoices, icon: NAV_ICONS.invoices },
      { to: "/admin/finance/payouts", label: NAV_COPY.admin.payouts, icon: NAV_ICONS.payouts },
    ],
  },
  {
    label: NAV_COPY.sections.operations,
    items: [
      { to: "/admin/skills", label: NAV_COPY.admin.skills, icon: NAV_ICONS.skills },
      { to: "/admin/candidates", label: NAV_COPY.admin.campaignCandidates, icon: NAV_ICONS.candidates },
      { to: "/admin/email-campaigns", label: NAV_COPY.admin.emails, icon: NAV_ICONS.emails },
      { to: "/admin/logs", label: NAV_COPY.admin.logs, icon: NAV_ICONS.logs },
    ],
  },
];

export function AdminLayout() {
  return (
    <RoleShell
      portalLabel="Admin Portal"
      logoTo="/admin"
      navSections={NAV_SECTIONS}
      profileTo="/admin/profile"
      avatarFallback="A"
    />
  );
}
